import React, { useState } from 'react';

import { useHistory } from 'react-router';

import MenuItem from '@material-ui/core/MenuItem';

import { PENDING_ACTION_TAB_CONFIG } from '../admin/components/pending-admin-action';

import { AddOrganizationOrAccount } from '../admin/add-organization-or-account';
import { ExportAccountScoresDialog } from '../admin/export-account-scores-dialog';
import { ReopenAccount } from '../admin/reopen-account';
import { apiHost } from '../api/api';
import { ClearFeatureGateCacheMenuItem } from '../feature-gates/components/clear-feature-gate-cache-menu-item';
import { UiButton } from '../ui/ui-button';
import { UiKebabMenu } from '../ui/ui-kebab-menu';
import { orgRoute } from '../web-routes';

import { PENDING_ADMIN_ACTION } from '../admin/util/admin-web-routes';

export const AccountsListAdminControls = () => {
  const [showScoreExportDialog, setShowScoreExportDialog] = useState(false);

  const history = useHistory();

  const handleAccountCreate = (newOrg: Org) => {
    history.push(orgRoute(newOrg.org_id));
  };

  const handleBullMqClick = () => {
    window.open(`${apiHost()}/admin/background-jobs`, '_blank');
  };

  const handleShowExportAccountScoresDialog = () => {
    setShowScoreExportDialog(true);
  };

  const handleCloseExportAccountScoresDialog = () => {
    setShowScoreExportDialog(false);
  };

  const handleCsTasksClick = () => {
    history.push(
      PENDING_ADMIN_ACTION(PENDING_ACTION_TAB_CONFIG['incomplete-employee-directory-import'].path),
    );
  };

  return (
    <>
      <div className="u-display-flex u-justifyContent-spaceBetween u-alignItems-flexEnd u-flexWrap-wrap">
        <div className="u-spread u-width-100">
          <div className="u-flex-center">
            <div className="u-margin-right-md">
              <AddOrganizationOrAccount onAdd={handleAccountCreate} />
            </div>
            <div className="u-margin-right-md">
              <ReopenAccount />
            </div>
            <div>
              <UiButton variant="secondary" linkTo="/admin/account-groups">
                Manage Account Groups
              </UiButton>
            </div>
            <div>
              <UiKebabMenu menuId="adminActionsMenu">
                <MenuItem onClick={handleBullMqClick}>BullMQ Dashboard</MenuItem>
                <MenuItem onClick={handleShowExportAccountScoresDialog}>
                  Export Account Scores
                </MenuItem>
                <MenuItem onClick={handleCsTasksClick}>CS Tasks</MenuItem>
                <ClearFeatureGateCacheMenuItem />
              </UiKebabMenu>
            </div>
          </div>
        </div>
      </div>
      {showScoreExportDialog && (
        <ExportAccountScoresDialog onClose={handleCloseExportAccountScoresDialog} />
      )}
    </>
  );
};
